export const FETCH_TRACKING_SETUP_DATA_FAILURE =
  'FETCH_TRACKING_SETUP_DATA_FAILURE';
export const FETCH_TRACKING_SETUP_DATA_REQUEST =
  'FETCH_TRACKING_SETUP_DATA_REQUEST';
export const FETCH_TRACKING_SETUP_DATA_SUCCESS =
  'FETCH_TRACKING_SETUP_DATA_SUCCESS';
